import * as Icons from "lucide-react";
import { expertise } from "../data/profile";
import { Reveal, Overline, AnimatedHeading } from "./Reveal";

export const Expertise = () => (
  <section id="expertise" className="py-16 sm:py-20 lg:py-24">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="max-w-2xl">
        <Overline>Core Competencies</Overline>
        <AnimatedHeading className="font-display text-3xl sm:text-4xl font-bold text-navy tracking-tight mt-4 leading-snug">
          Areas of Expertise
        </AnimatedHeading>
        <p className="mt-4 text-lg" style={{ color: "#4B5A69" }}>
          Two decades of leadership across the full spectrum of healthcare management and quality.
        </p>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 auto-rows-fr">
        {expertise.map((e, i) => {
          const Icon = Icons[e.icon] || Icons.Activity;
          return (
            <Reveal key={e.title} delay={i * 0.06} className={e.span}>
              <div
                data-testid={`expertise-card-${i}`}
                className="group h-full bg-white border border-[#E2E5E1] rounded-2xl p-8 hover:-translate-y-1 hover:shadow-[0_24px_40px_-24px_rgba(11,29,46,0.35)] transition-all duration-300"
              >
                <div className="h-12 w-12 rounded-xl bg-navy/5 flex items-center justify-center text-teal group-hover:bg-navy group-hover:text-bone group-hover:rotate-6 group-hover:scale-110 transition-all duration-300">
                  <Icon size={24} />
                </div>
                <h3 className="font-display text-xl font-bold text-navy mt-6 group-hover:text-teal transition-colors">{e.title}</h3>
                <p className="mt-3 text-sm leading-relaxed" style={{ color: "#4B5A69" }}>
                  {e.desc}
                </p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
